export const ROUTE_PERMISSION_REJECTION_REASON = {
  underPaywall: 'underPaywall',
  unaccepted: 'unaccepted',
};

export enum EDayOfWeek {
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  sunday = 'sunday',
}

export enum EDayOfWeekShort {
  mon = 'mon',
  tue = 'tue',
  wed = 'wed',
  thu = 'thu',
  fri = 'fri',
  sat = 'sat',
  sun = 'sun',
}

export enum ETimeUnit {
  millisecond = 'millisecond',
  milliseconds = 'milliseconds',
  second = 'second',
  minute = 'minute',
  hour = 'hour',
  day = 'day',
  week = 'week',
  month = 'month',
  year = 'year',
  date = 'date',
}

export enum ECurrency {
  rub = 'RUB',
  usd = 'USD',
  eur = 'EUR',
  cny = 'CNY',
  byn = 'BYN',
}

export enum ECurrencyCode {
  rub = '643',
  usd = '840',
  eur = '978',
  cny = '156',
  byn = '933',
}

export enum EControlAppearance {
  inline = 'inline',
  outline = 'outline',
}

export enum EPermissionComparisonFunction {
  OR = 'OR',
  AND = 'AND',
}

export enum EInequalitySymbol {
  less = 'less',
  greater = 'greater',
}

export enum EInputType {
  text = 'text',
  textarea = 'textarea',
  number = 'number',
  file = 'file',
}

export enum ELayout {
  vertical = 'vertical',
  horizontal = 'horizontal',
}

export const DayOfWeekSequence = {
  [EDayOfWeek.monday]: 1,
  [EDayOfWeek.tuesday]: 2,
  [EDayOfWeek.wednesday]: 3,
  [EDayOfWeek.thursday]: 4,
  [EDayOfWeek.friday]: 5,
  [EDayOfWeek.saturday]: 6,
  [EDayOfWeek.sunday]: 7,
};

export const DayOfWeekLabelShort = {
  [EDayOfWeek.monday]: 'Пн',
  [EDayOfWeek.tuesday]: 'Вт',
  [EDayOfWeek.wednesday]: 'Ср',
  [EDayOfWeek.thursday]: 'Чт',
  [EDayOfWeek.friday]: 'Пт',
  [EDayOfWeek.saturday]: 'Сб',
  [EDayOfWeek.sunday]: 'Вс',
};

// относится к платформенному контексту
export const ROUTE_TYPE = {
  admin: 'admin',
  private: 'private',
  public: 'public',
  unauthenticated: 'unauthenticated',
};

export const START_RU_ALPHABET_IN_UNICODE = 1040;

export const ONE_SECOND = 1000;
export const ONE_MINUTE = 60000;
export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = 3600;
export const MILLISECONDS_IN_HOUR = 3600000;
export const SECONDS_IN_DAY = 86400;
export const MILLISECONDS_IN_DAY = 86400000;
export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;
export const DAYS_IN_WEEK = 7;
export const DAYS_IN_YEAR = 365;

export const DEFAULT_PAGE_SIZES = [20, 50, 100];

export const REGEX_PATTERNS = {
  /** Допускает только целые числа и числа с запятой */
  onlyIntAndFloatNumbers: /^\d+(?:[.,]\d+)?$/,
  /** Допускает только целые числа */
  onlyIntNumbers: /^[0-9]*$/,
  /** Допускает только email */
  onlyEmail: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  /** Строка содержит буквы в верхнем и нижнем реестре */
  containsLowercaseAndUppercaseLetters: /(?=.*[a-zа-я])(?=.*[A-ZА-Я])/,
  /** Строка содержит хотя бы одну цифру */
  containsAtLeastOneDigit: /(?=.*\d)/,
  /** Российский номер телефона */
  russianPhoneNumber: /^(\+7|7)\d{10}$/g,
  /** Иностранный номер телефона */
  foreignPhoneNumber: /^[^7]\d{8,18}$/g,
  /** Допустит число больше нуля */
  biggerThanZero: /^[1-9]\d*$/,
  /** Допускает только целые числа и буквы кириллицы */
  onlyIntNumbersOrCyrillicLetters: /^[А-Яа-я0-9]+$/,
  /** HTML тэг */
  htmlTag: /(<([^>]+)>)/g,
  /** Escape-последовательности (амперсанд | левая угловая скобка | правая угловая скобка | парные кавычки | одинарные кавычки) */
  escapedHtml: /&(?:amp|lt|gt|quot|#(0+)?39);/g,
};

// относится к платформенному контексту
export enum EViewState {
  idle = 'idle',
  loading = 'loading',
  done = 'done',
  withError = 'withError',
  notFound = 'notFound',
  forbidden = 'forbidden',
}

// относится к платформенному контексту
export enum EAppState {
  /** приложение инициализировано, запрос на проверку валидности токена еще не отправлен */
  initial = 'initial',
  /** процесс отправки запроса на проверку токена. выполняется после initial */
  checking = 'checking',
  /** отсутствие токена или после проверки валидности токена вернулся статус 401 */
  unauthenticated = 'unauthenticated',
  /** после проверки валидности токена вернулся статус 200, и пользователь не заблокирован */
  authenticated = 'authenticated',
  /** после авторизации пользователя, который не может пользоваться системой */
  interactionLocked = 'interactionLocked',
  /** технические работы */
  onMaintenance = 'onMaintenance',
}

// относится к платформенному контексту
export enum ETransitionMethod {
  onCheck = 'onCheck',
  onSuccessfulAuthentication = 'onSuccessfulAuthentication',
  onFailedAuthentication = 'onFailedAuthentication',
  onLogin = 'onLogin',
  onLogout = 'onLogout',
  onInteractionLock = 'onInteractionLock',
  onInteractionUnlock = 'onInteractionUnlock',
  onMaintenance = 'onMaintenance',
}

// относится к платформенному контексту
export enum EWasAuthBy {
  loginPassword = 'loginPassword',
  entryCode = 'entryCode',
  social = 'social',
  temporaryAccessSession = 'temporaryAccessSession',
}

export const API_ERROR_CODE = {
  // eslint-disable-next-line
  not_found: 'not_found',
};

// относится к платформенному контексту
export enum EUserSystemRole {
  admin = 'admin',
  support = 'support',
  user = 'user',
}

export const DATE_FORMAT = {
  /** 16:37 */
  hoursMinutes: 'HH:mm',
  /** 16:37+0300 */
  hoursMinutesTimezone: 'HH:mmZZ',
  /** 16:37:49 */
  hoursMinutesSeconds: 'HH:mm:ss',
  /** 13.08.2021 */
  fullDate: 'DD.MM.YYYY',
  /** 13.08.21 */
  fullDateWithShortYears: 'DD.MM.YY',
  /** 13.08.2021, 15:19 */
  fullDateWithHoursMinutes: 'DD.MM.YYYY, HH:mm',
  /** 18 февраля */
  dayWithMonth: 'DD MMMM',
  /** 18 февраля 2024 */
  dayMonthYear: 'DD MMMM YYYY',
  /** 02.10 */
  dayWithShortMonth: 'DD.MM',
  /** 02/2024 */
  monthYear: 'MM/YYYY',
  /** 16/2024 (16 неделя 2024 года) */
  weekYear: 'wo/YYYY',
  /** 2022-05-20 */
  UTCformat: 'YYYY-MM-DD',
  /** 2022-05-20 15:19 */
  UTCWithTimeFormat: 'YYYY-MM-DD HH:mm',
  /** 2023-07-05T10:50:00 */
  ISOLocal: 'YYYY-MM-DDTHH:mm:ss',
  /** 2021/08/13 15:19 */
  fullDateWithHoursMinutesSlashed: 'YYYY/MM/DD, HH:mm',
  /** 2024-08-14T14:00:00+02:00 */
  ISODateTimeWithZone: 'YYYY-MM-DDTHH:mm:ssZ',
  /** 2024-1 (1 неделя 2024 года) */
  ISOWeekYear: 'gggg-wo',
  /** 2024-01 (1 неделя 2024 года) */
  ISOWeekYearTwoDigits: 'gggg-WW',
};

export const DATE_PICKER_TOP_LEFT_PLACEMENT = {
  points: ['bl', 'bl'],
  targetOffset: [0, 38],
};

export const NO_BREAK_SPACE = '\u00A0';

export enum EKeyboardKey {
  escape = 'Escape',
  enter = 'Enter',
  tab = 'Tab',
  arrowDown = 'ArrowDown',
  arrowUp = 'ArrowUp',
}

export const ANY_TYPE_OPTION = {
  id: 'any-type',
  name: 'Любой',
};

// https://developer.mozilla.org/ru/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export enum EUploadFileFormat {
  xls = '.xls',
  xlsx = '.xlsx',
  png = '.png',
  bmp = '.bmp',
  csv = '.csv',
  xml = '.xml',
  html = '.html',
  htm = '.htm',
  tif = '.tif',
  rtf = '.rtf',
  gif = '.gif',
  jpeg = '.jpeg',
  jpg = '.jpg',
  ico = '.ico',
  svg = '.svg',
  tiff = '.tiff',
  webp = '.webp',
  doc = '.doc',
  docx = '.docx',
  txt = '.txt',
  pdf = '.pdf',
  zip = '.zip',
  rar = '.rar',
  '7z' = '.7z',
}

export enum EMimeType {
  xRar = 'application/x-rar',
}

// Moscow center coords for map
export const DEFAULT_COORDS = {
  lat: 55.752220,
  lon: 37.615560,
};

export const BYTES_IN_KILOBYTE = 1024;
export const BYTES_IN_MEGABYTE = 1048576;

export enum EProcessImportStatus {
  failed = 'failed',
  success = 'success',
}

export const BREAKPOINTS = {
  widemobile: 576,
  tablet: 768,
  widelaptop: 1024,
  desktop: 1440,
  mediumscreen: 1880,
  widescreen: 2560,
};

export enum EInputSize {
  large = 'large',
  middle = 'middle',
  small = 'small',
}

// относится к платформенному контексту
export enum EAccountType {
  personal = 'personal',
  corporate = 'corporate',
}

export const DAYS_WITH_LABEL = [
  {
    key: EDayOfWeek.monday,
    label: DayOfWeekLabelShort[EDayOfWeek.monday],
  },
  {
    key: EDayOfWeek.tuesday,
    label: DayOfWeekLabelShort[EDayOfWeek.tuesday],
  },
  {
    key: EDayOfWeek.wednesday,
    label: DayOfWeekLabelShort[EDayOfWeek.wednesday],
  },
  {
    key: EDayOfWeek.thursday,
    label: DayOfWeekLabelShort[EDayOfWeek.thursday],
  },
  {
    key: EDayOfWeek.friday,
    label: DayOfWeekLabelShort[EDayOfWeek.friday],
  },
  {
    key: EDayOfWeek.saturday,
    label: DayOfWeekLabelShort[EDayOfWeek.saturday],
  },
  {
    key: EDayOfWeek.sunday,
    label: DayOfWeekLabelShort[EDayOfWeek.sunday],
  },
];

// https://json-schema.org/understanding-json-schema/index.html
export enum EJsonSchemaType {
  string = 'string',
  integer = 'integer',
  number = 'number',
  boolean = 'boolean',
  array = 'array',
  null = 'null',
}

export enum EJsonSchemaStringFormat {
  date = 'date',
  dateTime = 'date-time',
}

export enum EConditionOfRequire {
  anyOf = 'any_of',
  allOf = 'all_of',
}

export enum EFileActionMode {
  actionAppend = 'append',
  actionReplace = 'replace',
}

export const DEFAULT_DEBOUNCE_DELAY = 300;

export const HALF_SECOND_DEBOUNCE_DELAY = 500;

export const ONE_SECOND_DEBOUNCE_DELAY = 1000;

export const FIVE_SECONDS_DEBOUNCE_DELAY = 5000;

export const QUARTER_OF_MINUTE_DELAY = 15000;

export const MAX_DISTANCE_TO_END_INFINITY_SCROLL = 150;

export const MIN_DISTANCE_TO_END_INFINITY_SCROLL = 100;

/** Интервал отправки подтверждения, что вкладка, обновляющая токен, не закрыта */
export const TOKEN_REFRESH_HEARTBEAT_INTERVAL = 3000;

/**
 * Максимальная задержка между пингами от вкладки, обновляющей токен.
 * При превышении считаем, что вкладка обновляющая токен, была закрыта.
 */
export const MAX_TOKEN_REFRESH_HEARTBEAT_DELAY = 9000;
